// extracted by mini-css-extract-plugin
module.exports = {"contentBlock":"ContentBlock_contentBlock__3jryP"};